var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFavoriteHeart = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#AAA",
  d: "M1.863 10.75c0 5.616 4.707 11.14 12.142 15.886.277.172.673.356.95.356s.672-.184.962-.356c7.422-4.746 12.129-10.27 12.129-15.886 0-4.667-3.204-7.963-7.475-7.963-2.44 0-4.417 1.16-5.616 2.94-1.174-1.767-3.178-2.94-5.617-2.94-4.271 0-7.475 3.296-7.475 7.963"
})));
export default SvgFavoriteHeart;